import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            内容分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按主题浏览，找到你感兴趣的知识领域</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => {
            const count = getArticlesByCategory(cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group block bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 text-lg font-heading font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{count} 篇文章</span>
                  <span className="text-xs font-medium text-accent-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    浏览 →
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}